import { Col, List, Avatar, Typography } from "antd";
import useAuthors from "../custom-hooks/useAuthors";
import { Layout } from "antd";
import useIsMobile from "../custom-hooks/useIsMobile";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";

const { Content } = Layout;
const { Title } = Typography;

export default function AuthorCard() {
  const authors = useAuthors();
  const [isMobile] = useIsMobile();

  return (
    <Content>
      <Col>
        <List
          itemLayout={isMobile ? "horizontal" : "vertical"}
          dataSource={authors}
          renderItem={(author) => (
            <List.Item key={author.fields.internalName}>
              <List.Item.Meta
                style={{ alignItems: "center", display: "flex" }}
                title={<Title level={3}>{author.fields.name}</Title>}
                avatar={
                  <Avatar
                    size={{
                      xs: 56,
                      sm: 64,
                      md: 70,
                      lg: 80,
                      xl: 100,
                      xxl: 100,
                    }}
                    src={author.fields.avatar.fields.file.url}
                  />
                }
              />
              {documentToReactComponents(author.fields.bio)}
            </List.Item>
          )}
        ></List>
      </Col>
    </Content>
  );
}
